/**
 * API helper — wraps fetch with JWT auth headers.
 * Mirrors the Mickey api module interface used by KEEPage and other shared components.
 */

function getToken() {
  return localStorage.getItem('mickey_token');
}

async function request(method, path, body) {
  const opts = {
    method,
    headers: {
      'Authorization': `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
    },
  };
  if (body !== undefined) opts.body = JSON.stringify(body);

  const res = await fetch(`/api${path}`, opts);

  if (res.status === 401) {
    localStorage.removeItem('mickey_token');
    window.location.href = '/login';
    // Mark this with its status like every refusal below, so a caller can skip
    // its own error words while the browser leaves for sign-in.
    const err = new Error('Unauthorized');
    err.status = 401;
    throw err;
  }

  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    // Attach the HTTP status so callers can branch on it structurally rather than
    // regex-matching the message (e.g. SOUL view treats 404 as "no row yet").
    const err = new Error(json.error || `Request failed (${res.status})`);
    err.status = res.status;
    // The whole answer too, for a caller that needs more than the message (LP-403: a refused draft's defaults).
    err.data = json;
    throw err;
  }
  return json;
}

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  put: (path, body) => request('PUT', path, body),
  patch: (path, body) => request('PATCH', path, body),
  delete: (path) => request('DELETE', path),
};
